import React from "react";

let remodelsimgPath = require.context("../../public/images/remodels", true);
let contactHero = remodelsimgPath("./Laidley Street, San Francisco, CA2.jpg");

const Contact = () => {
	return (
		<main className="contact-page">
			<section className="page-hero-image contact-hero-image">
				<img src={contactHero} alt="NY Engineering project exterior" />
				<div className="page-hero-overlay" />
				<div className="site-container page-hero-copy">
					<h1 className="page-title">Contact</h1>
					<p>We work with owners, architects, contractors, and designers. Please contact us for any structural engineering needs.</p>
				</div>
			</section>

			<section className="page contact-details-section">
				<div className="site-container contact-grid">
					<section>
						<div className="contact-block">
							<h2>New Project Inquiries</h2>
							<p><a href="mailto:nyengineering@sbcglobal.net">nyengineering@sbcglobal.net</a></p>
						</div>
						<div className="contact-block">
							<h2>General Inquiries</h2>
							<p><a href="mailto:nyengineering@sbcglobal.net">nyengineering@sbcglobal.net</a></p>
						</div>
						<div className="contact-block">
							<h2>Phone</h2>
							<p><a href="tel:+14155681270">1-(415)-568-1270</a></p>
						</div>
					</section>
					<section>
						<div className="contact-block">
							<h2>Mailing Address</h2>
							<p>850 S. Van Ness Ave<br />San Francisco, CA 94110</p>
						</div>
						<div className="contact-block contact-address-spaced">
							<h2>Office Address</h2>
							<p>3601 Taraval Street<br />San Francisco, CA 94116</p>
						</div>
						<div className="contact-block contact-address-spaced">
							<h2>Service Areas</h2>
							<p>California &amp; New York</p>
						</div>
					</section>
				</div>
			</section>
		</main>
	);
};

export default Contact;
